import React, { memo } from "react";

import StyledScrollbar from "../../../../Common/UIComponents/StyledScrollbar";
import ProductFieldDisplay from "./ProductFieldDisplay";

import { getProductDisplayData } from "../../utils";

import "./ProductListView.css";
import "./SpecDisplayTable.css";

function ProductListViewItem({ product, fields, linkReportJsonFields }) {
  const { titleToValue } = getProductDisplayData(product, fields, linkReportJsonFields);

  return (
    <li className="ProductListView__Capsule">
      <div className="ProductListView__CapsuleContent">
        <ProductFieldDisplay
          titleToValue={titleToValue}
          rowClassName="ProductListView__FieldRow"
        />
      </div>
    </li>
  );
}

const MemoizedProductListViewItem = memo(ProductListViewItem);

/**
 * Read-only 2-column grid of product capsules.
 * Used in Global Test Spec view mode to show products using the test.
 * Memoized items reduce re-renders for large product lists.
 */
function ProductListView(props) {
  const {
    products = [],
    fields = [],
    linkReportJsonFields = [],
  } = props;

  if (products.length === 0) {
    return (
      <div className="ProductListView__Container">
        <h3 className="ProductListView__Title">Products using this test</h3>
        <div className="ProductListView__Empty">No products found</div>
      </div>
    );
  }

  return (
    <div className="ProductListView__Container">
      <h3 className="ProductListView__Title">Products using this test</h3>
      <StyledScrollbar id="ProductListView__ScrollBar" className="ProductListView__Scrollbar">
        <ul className="ProductListView__Grid">
          {products.map((product, i) => (
            <MemoizedProductListViewItem
              key={product.product_id ?? `product-${i}`}
              product={product}
              fields={fields}
              linkReportJsonFields={linkReportJsonFields}
            />
          ))}
        </ul>
      </StyledScrollbar>
    </div>
  );
}

export default memo(ProductListView);
